import RECIST11 from '../guidelines/RECIST11';
import MRECIST11 from '../guidelines/MRECIST11';
import iRECIST from '../guidelines/iRECIST';
import RANOBM from '../guidelines/RANOBM';
import RANOBM5MM from '../guidelines/RANOBM5MM';
import CUSTOM from '../guidelines/CUSTOM';

const guidelines = {
  RECIST11,
  MRECIST11,
  iRECIST,
  RANOBM,
  RANOBM5MM,
  CUSTOM,
};

export default guidelines;
